import WpPage, { getWpInitialProps } from "components/wpPage/WpPage";
import LowRiskBusinessIdeasToStartIn2023 from "containers/wpPage/low-risk-business-ideas-to-start-in-2023";

export default function LowRiskBusinessIdeasToStartIn2023Page() {
  return (
    <WpPage seoKey="low-risk-business-ideas-to-start-in-2023">
      <LowRiskBusinessIdeasToStartIn2023 />
    </WpPage>
  );
}

LowRiskBusinessIdeasToStartIn2023Page.getInitialProps = getWpInitialProps;
